<template>
  <article
    class="border border-gray-100 rounded-[10px] p-8 w-full h-full flex flex-col transition-transform duration-200 hover:-translate-y-1.5"
  >
    <header class="flex items-start justify-between h-[46px]">
      <img :src="logoSrc" alt="logo" class="h-full object-contain max-h-[36px]" :class="logoClass" />
      <component :is="QuoteSvg" width="24" height="24" />
    </header>
    <div class="mt-3">
      <h5 class="font-semibold text-gray-900 font-alt h4">{{ quote }}</h5>
      <p v-if="description" class="mt-4 text-gray-600">{{ description }}</p>
    </div>
    <div class="grow" />
    <footer class="mt-4.5">
      <DecoratedLink
        target="_blank"
        external
        type="base"
        :href="mediaLink"
        text="Learn more"
        icon-name="arrow-up-right"
        icon="right-icon"
        weight="semibold"
      />
    </footer>
  </article>
</template>

<script setup lang="ts">
import QuoteSvg from './images/quote.svg'

const props = defineProps({
  logoSrc: {
    type: String,
    required: true,
  },
  logoClass: {
    type: String,
    required: false,
  },
  mediaLink: {
    type: String,
    required: true,
  },
  quote: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false,
  },
})
</script>
